"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultVariant = exports.sourceLanguages = exports.JSSLANG_PROPERTIES = exports.UNKNOWN_LOCATION = exports.MAX_LIST_DISPLAY_LENGTH = exports.MODULE_PARAMS_ID = exports.NATIVE_STORAGE_ID = exports.GLOBAL = exports.TRY_AGAIN = exports.CUT = void 0;
exports.CUT = 'cut'; // cut operator for Source 4.3
exports.TRY_AGAIN = 'try_again'; // command for Source 4.3
exports.GLOBAL = typeof window === 'undefined' ? global : window;
exports.NATIVE_STORAGE_ID = 'nativeStorage';
exports.MODULE_PARAMS_ID = 'moduleParams';
exports.MAX_LIST_DISPLAY_LENGTH = 100;
exports.UNKNOWN_LOCATION = {
    start: {
        line: -1,
        column: -1
    },
    end: {
        line: -1,
        column: -1
    }
};
exports.JSSLANG_PROPERTIES = {
    maxExecTime: 1000,
    factorToIncreaseBy: 10
};
exports.sourceLanguages = [
    { variant: 'base' },
    { variant: 'no-tco' },
    { variant: 'macro' }
];
exports.defaultVariant = 'base';
//# sourceMappingURL=constants.js.map